module.exports = __webpack_public_path__ + "img/monocycle-none-right.9634c4c5.jpg";